import React from 'react';

interface ErrorMessageProps {
    message: string;
}

export function ErrorMessage({ message }: ErrorMessageProps) {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="text-red-500 bg-red-50 px-6 py-4 rounded-lg border border-red-200">
                <span className="font-medium">Error:</span> {message}
            </div>
        </div>
    );
} 